import { i18n } from "~/i18n.config";

interface Props {
	pathname: string;
}

// With clean URLs the canonical for the default locale is the bare path; non-default
// locales are addressable via ?lang=<locale> on the same path. The pathname argument
// is already locale-free at the point this renders (handleUrlRedirect 307s any
// /<locale>/ prefix away before SSR), so no additional cleaning is needed here.
function canonicalUrl(pathname: string, locale: string): string {
	return locale === i18n.defaultLocale ? pathname : `${pathname}?lang=${locale}`;
}

export function AlternateHrefLang({ pathname }: Props): React.ReactNode {
	return (
		<>
			<link rel="alternate" href={pathname} hrefLang="x-default" />
			{i18n.locales.map((locale) => (
				<link key={locale} rel="alternate" href={canonicalUrl(pathname, locale)} hrefLang={locale} />
			))}
		</>
	);
}
